import { Button, withStyles } from '@material-ui/core';

export const StyledButton = withStyles({
  root: {
    backgroundColor: '#383c52',
    color: '#fff',
    padding: '12px 48px',
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: '8px',
    minWidth: '300px',
    '&:hover': {
      backgroundColor: '#2c2f3f',
    },
    '&:disabled': {
      backgroundColor: '#e0e0e0',
      color: '#9e9e9e',
    },
  },
})(Button);
